import ImagesSlider from 'assets/core/js/module/imagesSlider'

export default function (): void {
  ImagesSlider(document.querySelector<HTMLElement>('.booking__product .slider') as HTMLElement)
}
